import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable, switchMap } from 'rxjs';
import { AtributosIrfeService } from 'src/app/shared/services/atributos-irfe.service';
import { AtributoProcessoQuestaoService } from '../services/atributos-processo-questao.service';

@Injectable({
  providedIn: 'root',
})
export class listAtributosProcessoQuestaoResolve implements Resolve<boolean> {

  
  constructor(
    private service: AtributoProcessoQuestaoService,
    //AtributosProcessoQuestao
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
        return this.service.getListAtributos();
  }
}
